import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useResetScroll from "../../utils/useResetScroll";

export default function Character() {
  useResetScroll();
  
  const { characterId } = useParams();

  console.log("ref", characterId);

  useEffect(() => {
    if (characterId) {
      setTimeout(() => {
        window.location.href = `otaconnect://ota/Native?characterId=${characterId}`;
      }, 500); // Delay redirection to prevent blocking
    }
  }, [characterId]);

  return (
    <div className="w-full p-5 h-[60px] flex items-center bg-white justify-between">
      Its Working!!
    </div>
  );
}
